import { render, staticRenderFns } from "./shopEdit.vue?vue&type=template&id=68607b2e&scoped=true"
import script from "./shopEdit.vue?vue&type=script&lang=js"
export * from "./shopEdit.vue?vue&type=script&lang=js"
import style0 from "./shopEdit.vue?vue&type=style&index=0&id=68607b2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68607b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68607b2e')) {
      api.createRecord('68607b2e', component.options)
    } else {
      api.reload('68607b2e', component.options)
    }
    module.hot.accept("./shopEdit.vue?vue&type=template&id=68607b2e&scoped=true", function () {
      api.rerender('68607b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopList/shopEdit.vue"
export default component.exports